import React, { createContext, useContext } from 'react'
import { useSync } from '../hooks/useSync'

// The context will hold the return type of our hook
type SyncContextType = ReturnType<typeof useSync>

// Create a context with an initial value of null
const SyncContext = createContext<SyncContextType | null>(null)

/**
 * The SyncProvider component wraps its children in the SyncContext.Provider,
 * making the sync logic available to any child components.
 */
export const SyncProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const sync = useSync()
    return <SyncContext.Provider value={sync}>{children}</SyncContext.Provider>
}

/**
 * A custom hook to consume the SyncContext.
 * It ensures that the context is used within a SyncProvider.
 */
export const useSyncContext = () => {
    const context = useContext(SyncContext)
    if (!context) {
        throw new Error('useSyncContext must be used within a SyncProvider')
    }
    return context
} 